import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default class extends Controller {
  static targets = ["submitButton", "choice"];

  connect() {
    this.checkIfAllChecked();
  }

  haveAtLeastOneOption = (choice) => {
    return Array.from(choice.querySelectorAll("input[type=checkbox]")).some(
      (input) => input.checked
    );
  };

  allChecked() {
    return this.choiceTargets.every((choice) => {
      return this.haveAtLeastOneOption(choice);
    });
  }

  checkIfAllChecked() {
    if (this.allChecked()) {
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.disabled = true;
    }
  }

  fillRandom(event) {
    event.preventDefault();
    this.choiceTargets.forEach((choice) => {
      choice.querySelector("input[type=checkbox]").checked = true;
    });
  }
}
